import { LayaGL } from "../../../../layagl/LayaGL";
export class ComputeCommandBuffer {
    constructor() {
        if (LayaGL.renderDeviceFactory.createComputeContext) {
            this._context = LayaGL.renderDeviceFactory.createComputeContext();
        }
    }
    getResource() {
        return this._context;
    }
    clearCMDs() {
        this._context.clearCMDs();
    }
    addDispatchCommand(computeshader, shaderDefine, datas, dispatchParams) {
        let cmd = {
            shader: computeshader.getCacheShader(shaderDefine),
            shaderData: datas,
            dispatchParams: dispatchParams.clone()
        };
        this._context.addDispatchCommand(cmd);
    }
    ;
    addDispatchIndirectCommand(computeshader, shaderDefine, datas, indirectBuffer, indirectOffset) {
        let cmd = {
            shader: computeshader.getCacheShader(shaderDefine),
            shaderData: datas,
            indirectBuffer: indirectBuffer,
            indirectOffset: indirectOffset
        };
        this._context.addDispatchIndirectCommand(cmd);
    }
    addSetShaderDataCommand(shaderData, propertyID, shaderDataType, value) {
        this._context.addSetShaderDataCommand(shaderData, propertyID, shaderDataType, value);
    }
    ;
    addBufferToBufferCommand(src, dest, sourceOffset, destinationOffset, size) {
        this._context.addBufferToBufferCommand(src, dest, sourceOffset, destinationOffset, size);
    }
    ;
    addClearBufferCommand(dest, destoffset, destCount) {
        this._context.addClearBufferCommand(dest, destoffset, destCount);
    }
    addBufferToTextureCommand(src, srcTextureInfo, destTextureInfo, copySize) {
    }
    ;
    addTextureToBufferCommand(srcTextureInfo, rc, destTextureInfo, copySize) {
    }
    ;
    addTextureToTextureCommand(srcTextureInfo, destTextureInfo, copySize) {
        this._context.addTextureToTextureCommand(srcTextureInfo, destTextureInfo, copySize);
    }
    ;
    executeCMDs() {
        this._context.executeCMDs();
    }
    ;
    destroy() {
        this._context.destroy();
    }
    ;
}
